export const createTurboCanonicalItems = () => [];
